import request from '@/utils/request'

//获取预警通知列表页
export function getWarningList(params) {
  return request({
    url: '/wechat/push/warning/show',
    method: 'POST',
    params
  })
}

//一键全部已读
export function changeAllRead(params) {
  return request({
    url: '/wechat/push/amend/all',
    method: 'PUT',
    data: params
  })
}

//预警详情
export function getWarningDetail(params) {
  return request({
    url: '/wechat/push/warning/details',
    method: 'GET',
    params
  })
}

//单条数据已读
export function changeToRead(messagePushId) {
  return request({
    url: '/wechat/push/amend',
    method: 'put',
    data: { messagePushId }
  })
}
// 获取远程确认 待审批详情
export function getRemoteDetails(params) {
  return request({
    url: '/wechat/push/remote/details',
    method: 'GET',
    params
  })
}

// 远程确认人 同意、拒绝
export function remoteOps(data) {
  return request({
    url: '/wechat/remote',
    method: 'PUT',
    data
  })
}

//预警详情
export function getOcrDetail(params) {
  return request({
    url: `/wechat/push/ocr/match/details/${params.messagePushId}`,
    method: 'GET',
    params: {
      enterpriseId: params.enterpriseId,
      staffId: params.staffId
    }
  })
}

// 印章柜系统通知、预警通知详情
export function getYzgNotice(params) {
  return request({
    url: `/wechat/push/cabinet/details`,
    method: 'GET',
    params
  })
}

// 消息数量
export function messageAmount() {
  return request({
    url: '/wechat/push/message/amount',
    method: 'GET'
  })
}
